module.exports = __webpack_public_path__ + "static/media/cdb9.57696a07.png";